import api from './api';

const transferPinAPI = {
  // Get transfer PIN status
  getStatus: async () => {
    try {
      const response = await api.get('/transfer-pin/status');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Set transfer PIN
  setPin: async (pin, pinConfirmation) => {
    try {
      const response = await api.post('/transfer-pin/set', {
        pin,
        pin_confirmation: pinConfirmation
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Change transfer PIN
  changePin: async (currentPin, newPin, newPinConfirmation) => {
    try {
      const response = await api.post('/transfer-pin/change', {
        current_pin: currentPin,
        new_pin: newPin,
        new_pin_confirmation: newPinConfirmation
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Validate transfer PIN
  validatePin: async (pin) => {
    try {
      const response = await api.post('/transfer-pin/validate', {
        pin
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Reset transfer PIN
  resetPin: async (password, confirmReset) => {
    try {
      const response = await api.post('/transfer-pin/reset', {
        password,
        confirm_reset: confirmReset
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Check if PIN is required
  checkPinRequired: async () => {
    try {
      const response = await api.get('/transfer-pin/check-required');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default transferPinAPI;
